import React from "react"
import { Container } from "react-bootstrap"

const Gmap = () => {
  return (
    <div className="maps">
      <Container>
        <h1 className="my-4 text-lg-start text-center ">
          Find <span className="green">US</span>
        </h1>
      </Container>
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d180.25787803325383!2d-79.3935002!3d43.7079295!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b33253bf4ae19%3A0xc398650c45eda4ef!2sToronto%2C%20ON%20M4P%201G4%2C%20Canada!5e0!3m2!1sen!2sin!4v1620460342391!5m2!1sen!2sin"
        height="450"
        title="maps"
        frameBorder="0"
        style={{ border: 0 }}
        allowFullScreen=""
        aria-hidden="false"
      ></iframe>
    </div>
  )
}

export default Gmap
